import type { AdTemplate } from '@shared/schema';
import { adStyleOf } from './ad-style';

// The first row keeps the approved Caraway examples. The second row adds four
// distinct ways to tell an ad story, each represented by an existing global
// library image. IDs identify examples; the live library supplies the URL.
export const INSPIRATION_CATEGORIES = [
  { style: 'Social Proof', preferredId: 2194 },
  { style: 'Sale', preferredId: 2193 },
  { style: 'Us vs Them', preferredId: 2192 },
  { style: 'Product Launch', preferredId: 2191 },
  { style: 'Problem-Solution', preferredId: 2002 },
  { style: 'UGC Style', preferredId: 2187 },
  { style: 'Education', preferredId: 1754 },
  { style: 'How It Works', preferredId: 1240 },
] as const;

function isBunnyImage(template: AdTemplate): boolean {
  return template.isGlobal && template.mediaType !== 'video' && /^https:\/\/[^/]+\.b-cdn\.net\//i.test(template.imageUrl);
}

export function selectInspirationCards(templates: AdTemplate[]) {
  return INSPIRATION_CATEGORIES.flatMap(({ style, preferredId }) => {
    const matching = templates.filter(template => adStyleOf(template) === style && isBunnyImage(template));
    const template = matching.find(template => template.id === preferredId) ?? matching[0];
    return template ? [{ style, template }] : [];
  });
}
